import { TooltipHoverTarget } from "@repo/ui/tooltip/hoverTarget";
import { SimpleTooltip } from "@repo/ui/tooltip/simpleTooltip";
import { TooltipTrigger } from "@repo/ui/tooltip/tooltipTrigger";
import { IconSparkles } from "@tabler/icons-react";
import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { PH_MASK_CLASS } from "../analytics/sessionRecordingMasking.js";

interface ContactNameLinesProps {
  primaryDisplayName: string | undefined;
  secondaryDisplayName: string | undefined;
  isGeneratedFromTranscript: boolean;
  /** Extra inline content after the name on the first line. */
  children?: ReactNode;
}

/** A contact's two display-name lines, flagging a name found in the transcript. */
export const ContactNameLines: FC<ContactNameLinesProps> = (props) => {
  const {
    primaryDisplayName,
    secondaryDisplayName,
    isGeneratedFromTranscript,
    children,
  } = props;

  // To avoid an excessively wide column, reserve 10rem for the title and allow it to grow into any remaining space.
  return (
    <>
      <div className="flex items-center gap-2">
        <span
          className={twMerge(
            "w-[10rem] max-w-fit flex-auto truncate font-medium",
            PH_MASK_CLASS,
          )}
        >
          {primaryDisplayName}
        </span>

        {isGeneratedFromTranscript ? (
          <TooltipTrigger>
            <TooltipHoverTarget shape="rounded">
              <IconSparkles className="size-4 text-purple-500" />
            </TooltipHoverTarget>
            <SimpleTooltip>
              This name was found in the transcript. Make sure to check for
              accuracy.
            </SimpleTooltip>
          </TooltipTrigger>
        ) : null}

        {children}
      </div>

      <div className="flex">
        {secondaryDisplayName ? (
          <span
            className={twMerge(
              "w-[15rem] max-w-fit flex-auto truncate text-gray-600",
              PH_MASK_CLASS,
            )}
          >
            {secondaryDisplayName}
          </span>
        ) : null}
      </div>
    </>
  );
};
